<template>
    <div class="wrapper success_base">
        <div class="success_title">
            <img src="../../assets/image/secondary/success.png" class="success_title_img">
            <p class="title">恭喜你报名成功</p>
            <p class="tip">请注意查收短信，接听客服电话。</p>
        </div>
        <div class="success_from">
            <!--            <img src="../../assets/image/secondary/give.jpg" class="succes_give_img">-->
            <div class="activity_info">
                <p>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-shijian"></use>
                    </svg>
                    <span>{{ stime_etime}}</span>
                </p>
                <p v-if="address!=''">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-didian"></use>
                    </svg>
                    <span>{{ address}}</span>
                </p>
            </div>
            <div class="divider_box">
                <el-divider><b style="font-size: 14px">帮朋友报名</b></el-divider>
            </div>
            <div class="success_sign_form">

                <van-form ref="actionForm" style="padding-bottom: 5px">
                    <div class="field_outbox">
                        <van-field
                            :border="false"
                            v-model="action_form.name"
                            name="姓名"
                            placeholder="请输入朋友姓名"
                        />
                    </div>
                    <div class="field_outbox">
                        <van-field
                            :border="false"
                            type="tel"
                            v-model="action_form.phone"
                            name="电话"
                            placeholder="请输入朋友电话"
                        />
                    </div>
                    <div class="field_outbox" v-if="is_city">
                            <van-field
                                :border="false"
                                v-if="is_city"
                                v-model="action_form.city"
                                is-link
                                readonly
                                placeholder="请帮朋友选择城市"
                                @click="city_show = true"
                            />
                        </div>
                    <div v-if="tid!=5">
                        <div class="field_outbox">
                        <van-field
                            :border="false"
                            v-model="action_form.car_name"
                            is-link
                            readonly
                            placeholder="请帮朋友选择意向车型"
                            @click="is_dialog_car = true"
                        />
                    </div>
                     </div>
                    <div class="submit_btn" @click="submitForm" style="margin-top: 20px">立即报名</div>
                </van-form>
            </div>
        </div>
        <div class="success_tail">
            <img v-if="tid!=5" src="../../assets/image/secondary/car_tail.png" alt="尾图"/>
            <img v-if="tid==5" src="../../assets/image/secondary/tail.png" alt="尾图"/>
        </div>
        <div class="success_button_copy" @click="clk_copy">
            <img src="../../assets/image/secondary/btn_copy.jpg" alt="复制分享"/>
        </div>
        <!--  品牌车型vant-->
        <van-popup v-model="is_dialog_car" position="right" :style="{height: '100%',width: '80%'}" v-if="!custom_car">
            <carlist_img :activity_id="Number(activity_id)" :custom_car="Number(custom_car)"
                         @query="query_car"></carlist_img>
        </van-popup>

        <van-popup v-model="is_dialog_car" position="bottom" :style="{height: '80%',width: '100%'}" v-if="custom_car">
            <carlist_noimg :activity_id="Number(activity_id)" :custom_car="Number(custom_car)"
                           :is_dialog_car="is_dialog_car"
                           @query="query_car" @handleClose="handleClose"></carlist_noimg>
        </van-popup>
        <!-- 成功弹框-->
        <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" :show-close="false">
            <el-result icon="success" title="赠票成功">
            </el-result>
        </el-dialog>
        <!-- 城市选择弹框-->
        <!--  :style="{height: '50%'}" :lock-scroll="false"-->
        <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
            <!--  style="height: 100%;overflow-x: hidden;overflow-y: auto"-->
            <van-cascader
                v-model="cascaderValue"
                title="请选择所在地区"
                :options="citys"
                :fieldNames="cityNames"
                @close="city_show = false"
                @finish="finishCity"
            />
        </van-popup>
    </div>
</template>

<script>
    import carlist_img from "@/components/carlist_img";
    import carlist_noimg from "@/components/carlist_noimg";
    import _wx from "@/common/_wx";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import lib_city from "@/libs/lib_city";
    import cache_url from "@/cache/cache_url";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import Toast from "vant/lib/toast";
    import _copyUrl from "@/common/_copyUrl";

    let action_form = {
        brand_name: '', //品牌名称
        brand_id: 0,  // 品牌id
        series_id: 0, // 车型id
        series_name: '', // 车型名称
        car_name: '', //品牌/车型名称
        name: '', // 姓名
        phone: '', //电话
        city: '', //城市
    };
    export default {
        name: "success_friend",
        components: {
            carlist_img,
            carlist_noimg,
        },
        data() {
            return {
                activity_id: 0, //活动ID
                tids: "", //模板ID
                channel: 0, //渠道ID
                channel_name: '', //渠道名
                ui: {}, //模板信息
                custom_car: 0, // 是否自定义车型库
                title: '', //
                share_theme: '', //分享主题
                tid: 1, // 5是非汽车行业
                theme: '', // 主题
                stime: 0,
                etime: 0,
                address: '', // 活动地点
                stime_etime: '', // 活动时间
                is_city: false, // 表单城市项，默认无城市
                is_stop: false,//活动是否已结束
                is_query_car: false, //是否选择车型
                action_form: action_form,
                //城市联级选择
                citys: [], //城市数据
                cascaderProps: {
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "children", //指定选项的子选项
                    emitPath: false, //该节点数组
                }, //配置项
                car_list: [], //品牌数据
                is_dialog_car: false, // 车型弹框
                is_success: false, //成功弹框

                //监测
                event_list: [],
                validFlag: false,

                // vant相关
                city_show: false, //城市flag
                cascaderValue: '',
                cityNames: {
                    text: 'name',
                    value: 'id',
                    children: 'children',
                },

                id: 0,
            }
        },

        created() {
            // 地址栏信息
            this.activity_id = _geturl("activity_id");//项目
            this.tids = _geturl("tids");//模板
            this.channel = _geturl("channel");//渠道
            this.channel_name = _geturl('channel_name'); //渠道名

            this.id = _geturl('id');

            // 项目信息
            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);
            //报名信息

        },
        methods: {

            //初始化项目信息 data是lib_activity.info的response.data
            init_info(data) {
                console.log(data)
                this.title = data.activity.theme;
                document.title = this.title;
                this.custom_car = data.activity.custom_car;
                this.share_theme = data.activity.share_theme;
                this.stime = data.activity.stime;
                this.etime = data.activity.etime;
                this.stime_etime = _time._range_date(this.stime*1000, this.etime*1000);
                this.address = data.activity.address;
                this.tid = data.activity.tid;
                console.log(this.tid, '===tid')
                this.ui = data.ui;
                // 项目结束
                if (!data.activity.state || (_time._current() > data.activity.etime)) {
                    this.is_stop = true;
                    return;
                }

                // 判断是否有城市
                let city = []
                if (data.activity.city) {
                    city = data.activity.city.split(',');
                }
                if (city.length == 1 && city[0] > 0) {
                    //单城市项目
                    this.is_city = false;
                } else {
                    //多城市项目
                    this.is_city = true;
                    this.getCity(data.activity.city)
                }

                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }

            },
            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.title;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },
            // 加载城市
            getCity(city) {
                let that = this;
                lib_city.list(city, function (data) {
                    that.citys = data;
                })
            },

            clk_brand() {
                this.is_dialog_car = true
            },
            // 父组件事件
            query_car(brand_id, brand_name, series_id, series_name) {
                this.action_form.brand_id = brand_id;
                this.action_form.brand_name = brand_name;
                this.action_form.series_id = series_id;
                this.action_form.series_name = series_name;
                this.action_form.car_name = brand_name + '/' + series_name
                this.is_dialog_car = false
            },
            // 清空表单
            resetForm() {
                this.action_form.brand_name = '';
                this.action_form.name = '';
                this.action_form.phone = '';
                this.action_form.city = '';
                this.action_form.car_name = '';
            },
            //提交表单
            submitForm() {
                if (this.is_stop == true) {
                    Toast('项目已结束');
                    return;
                }
                if (!this.action_form.name) {
                    Toast('请输入姓名');
                    return;
                }
                if(this.action_form.name && this.action_form.name.length>20) {
                    Toast('请输入正确的姓名');
                    return;
                }
                if (!this.action_form.phone) {
                    Toast('请输入手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请输入正确的手机号');
                    return;
                }
                if (this.is_city && !this.action_form.city) {
                    Toast('请选择城市');
                    return;
                }
                if (this.tid!=5 && !this.action_form.series_id) {
                    Toast('请选择品牌车型');
                    return;
                }

                let cityArr = this.action_form.city.split('/'); // vant形式
                let location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';
                let url = window.location.href;
                let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
                let params = {
                    activity_id: this.activity_id,
                    channel_code: this.channel,
                    channel_name: this.channel_name,
                    url,
                    location,
                    form_name: this.action_form.name,
                    form_phone: this.action_form.phone,
                    form_brand: this.action_form.brand_name,
                    form_series: this.action_form.series_name,
                    form_ui_id,
                };

                let that = this;
                lib_clue.receive(params, function (data) {
                    setTimeout(() => {
                        that.is_success = true;
                        // 延迟关闭
                        setTimeout(() => {
                            that.is_success = false;
                            that.resetForm()
                        }, 1000)
                    }, 500)
                })
            },
            // 复制
            clk_copy() {
                let url = cache_url.empty() ? window.location.href : cache_url.get()
                _copyUrl.copyUrl("@ [" + this.theme + "] 我已领取了门票，和我一起来看看!>>" + ' ' + url)
            },

            // vant相关
            finishCity({selectedOptions}) {
                this.city_show = false;
                this.action_form.city = selectedOptions.map((option) => option.name).join('/');
            },

            handleClose(flag) {
                this.is_dialog_car = flag;
            }
        },
        watch: {
            is_dialog_car(val) {
                let scrollWidth = document.innerWidth - document.documentElement.offsetWidth;
                if (val) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.paddingRight = scrollWidth + 'px'
                } else {
                    document.body.style.overflow = 'auto';
                    document.body.style.paddingRight = scrollWidth + 'px'
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    @import "../../assets/style/autoshow/form.less";
    // form
    @import "../../assets/style/common/successful.less"; // 成功
    .mt0 {
        margin-top: 0px;
    }

    .form_btn_img {
        width: 100%;
        height: auto;
        margin-top: 8px;

        img {
            display: inline-block;
            width: 100%;
        }
    }

    .succes_form_body {
        .el-form-item {
            margin-bottom: 10px;
        }
    }

    .field_outbox {
        margin-bottom: 10px;
    }
</style>
